import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ErrorStateService {
    public lastError: HttpErrorResponse | null = null;
    private progressEventErrorOccurred = false;
    private serverErrorOccurred = false;

    setProgressEventErrorOccurred(): void {
        this.progressEventErrorOccurred = true;
    }

    hasProgressEventErrorOccurred(): boolean {
        return this.progressEventErrorOccurred;
    }

    setServerErrorOccurred(): void {
        this.serverErrorOccurred = true;
    }

    hasServerErrorOccurred(): boolean {
        return this.serverErrorOccurred;
    }
}
